import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {WindowService} from '../../../../../../shared/services/window';
import {CaptionInput} from '../caption.input';
import {ViewController, NavParams} from 'ionic-angular';

/**
 * Class for the CaptionInputModalComponent
 * @class CaptionInputModalComponent
 *
 * @description Full screen implementation of the [Quill Editor]{@link https://quilljs.com/} for the caption input
 * Created so we can modify the template as needed
 */
@Component({
  selector: 'advtech-caption-input-modal',
  templateUrl: './caption-input-modal.component.html',
})
export class CaptionInputModalComponent implements AfterViewInit {
  /**
   * The title for the modal
   * @type {string}
   */
  title: string;

  /**
   * The value of the main body input
   * @type {string}
   */
  parentValue: string;

  /**
   * The body input from the template
   * @type {BodyInput}
   */
  @ViewChild('bodyInput')
  bodyInput: CaptionInput;

  /**
   * @constructor
   * @param {WindowService} windowService
   * @param {NavParams} navParams
   * @param {ViewController} viewController
   */
  constructor(public windowService: WindowService,
              private navParams: NavParams,
              private viewController: ViewController) {
    this.title = this.navParams.get('title');
    this.parentValue = this.navParams.get('value');
  }

  /** @inheritdoc */
  ngAfterViewInit(): void {
    this.bodyInput.setValue(this.parentValue);
    this.bodyInput.quillEditor.quillEditor.getModule('history').clear();

    setTimeout(() => {
      this.placeCaretAtEnd();

    }, 600);
  }

  /**
   * Dismisses the modal and passes the bodyInputs value through
   * @returns {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.viewController.dismiss({value: this.bodyInput.getValue()});
  }

  /**
   * Places the caret at the end of the last element and scrolls it there
   * @return {void}
   */
  placeCaretAtEnd(): void {
    const el = this.bodyInput.quillEditor.quillEditor.root;
    el.focus();
    const range = document.createRange();
    let sel = this.windowService.window.getSelection();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);

    if (this.parentValue !== '<p><br></p>') {
      setTimeout(() => {
        sel = this.windowService.window.getSelection();
        if (sel.rangeCount > 0) {
          el.scrollTop = el.lastElementChild.offsetTop;
        }
      }, 200);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/caption/caption-input-modal/caption-input-modal.component.ts